import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { StickySidebar } from "./StickySidebar";
import { WizardProfileTab } from "./WizardProfileTab";

import "./WizardSidebarMenu.scss";

export const WizardSidebarMenu = ({
  menuClassName,
  sidebarMenuHeader,
  tabs,
  activeTab,
  onTabKeyPress,
  onTabClick,
}) => (
  <StickySidebar
    menuClassName={menuClassName}
    sidebarMenuHeader={sidebarMenuHeader}
    activeTab={activeTab}
    tabs={tabs}
  >
    <div className="sr-only" id="profile-tablist">
      <FormattedMessage id={"wizard_profile_tablist"} />
    </div>
    <div
      className="wizard-tablist"
      role="tablist"
      aria-labelledby="profile-tablist"
    >
      {_.map(tabs, ({ id, header }) => (
        <WizardProfileTab
          key={id}
          id={id}
          onClick={onTabClick}
          onKeyPress={onTabKeyPress}
          isActive={activeTab === id}
        >
          {header}
        </WizardProfileTab>
      ))}
    </div>
  </StickySidebar>
);

WizardSidebarMenu.propTypes = {
  menuClassName: PropTypes.string,
  sidebarMenuHeader: PropTypes.node,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      header: PropTypes.node.isRequired,
      content: PropTypes.node,
    })
  ).isRequired,
  onTabKeyPress: PropTypes.func.isRequired,
  onTabClick: PropTypes.func,
  activeTab: PropTypes.string,
};
